
<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      alerta: state => state.moduleAlerta.alerta,
    }),
  },
  methods: {
    btnSalvarNovo() {
      this.$store.dispatch("CADASTRARALERTA", {
          usuario: this.usuario.codUsuario,
          cidade: this.user.cidade,
          alerta: this.alerta
      }).then((result) => {
        if(result){
          this.$swal.fire({
            title: "Gravar Alerta",
            text: 'Gravado com Sucesso',
            icon: "success"
          })
          this.$emit('limparCampos')
        }
        else{
          this.$swal.fire({
            title: "Gravar Alerta",
            text: 'Erro na Tentativa de gravar o alerta',
            icon: "error"
          })
        }
        }
      )
    },
  }
}
</script>

<template>
  <b-button :disabled='!alerta.placaValido && !alerta.placaCompleta' @click='btnSalvarNovo' :variant="!ativar ? 'success' : ''">Salvar</b-button>
</template>

<style>

</style>